import {
  ChatWidgetText,
  isSafeWidgetImage,
  isSafeWidgetUrl,
  ShowMeWidget,
} from "../../../Helper/ChatWidget";
import { CursorIcon } from "../ChatWidgetIcons";
import { Button, Card, Foot, openWidgetUrl } from "../ChatWidgetPrimitives";
import "./ShowMeCard.scss";

/** The page with `?gleap_highlight=<target>` (the SDK highlight is phase 2). */
const highlightUrl = (url: string, target?: string) => {
  if (!target) return url;
  try {
    const parsed = new URL(url);
    parsed.searchParams.set("gleap_highlight", target);
    return parsed.toString();
  } catch (error) {
    return url;
  }
};

/** A sketch of the page with the control to press, when there's no screenshot. */
const PagePreview = ({ target }: { target?: string }) => (
  <div className="cw-showme-sketch" aria-hidden="true">
    <div className="cw-showme-sketch-nav">
      <span style={{ width: "60%" }} />
      <span />
      <span className="cw-showme-sketch-strong" style={{ width: "80%" }} />
      <span style={{ width: "70%" }} />
    </div>
    <div className="cw-showme-sketch-main">
      <span
        className="cw-showme-sketch-strong"
        style={{ width: "45%", height: 10 }}
      />
      <span style={{ width: "90%" }} />
      <span style={{ width: "75%" }} />
    </div>
    {target && <span className="cw-showme-target">{target}</span>}
    <CursorIcon size={22} className="cw-showme-cursor" />
  </div>
);

/** 02 Show me: points at a place in the app and opens it. */
export const ShowMeCard = ({
  widget,
  text,
}: {
  widget: ShowMeWidget;
  text: ChatWidgetText;
}) => {
  const hasUrl = isSafeWidgetUrl(widget.url);
  return (
    <Card className="cw-showme" label={widget.title}>
      <div className="cw-showme-preview">
        {isSafeWidgetImage(widget.preview) ? (
          <img
            src={widget.preview}
            alt=""
            loading="lazy"
            referrerPolicy="no-referrer"
          />
        ) : (
          <PagePreview target={widget.target} />
        )}
      </div>
      <div className="cw-pad cw-showme-body">
        {widget.breadcrumb && (
          <div className="cw-showme-crumb">
            <span className="cw-showme-fav" aria-hidden="true" />
            <span>{widget.breadcrumb}</span>
          </div>
        )}
        <div className="cw-h cw-showme-title">{widget.title}</div>
        {widget.description && (
          <div className="cw-sm cw-body cw-showme-desc">
            {widget.description}
          </div>
        )}
      </div>
      {hasUrl && (
        <Foot>
          {widget.target ? (
            <>
              <Button
                variant="ghost"
                className="cw-showme-open"
                onClick={() => openWidgetUrl(widget.url)}
              >
                {text("widgetOpen")}
              </Button>
              <Button
                onClick={() =>
                  openWidgetUrl(highlightUrl(widget.url, widget.target))
                }
              >
                <CursorIcon size={15} />
                {text("widgetShowMe")}
              </Button>
            </>
          ) : (
            <Button onClick={() => openWidgetUrl(widget.url)}>
              {text("widgetOpen")}
            </Button>
          )}
        </Foot>
      )}
    </Card>
  );
};
